<template>
  <v-autocomplete
    :items="items"
    :label="label"
    item-text="node.name"
    item-value="node"
    v-model="selectedTemplate"
    @change="onChange"
    :outlined="outlined"
    clearable
    :hide-details="hideDetails"
    :dense="dense"
  ></v-autocomplete>
</template>

<script>
import { ALL_TEMPLATES_SEARCH_QUERY } from "../../../constants/graphql";
import { removeGQLTypename } from "../../../helpers";
export default {
  name: "TemplateListSelect",
  props: {
    outlined: {
      type: Boolean,
      default: () => false,
    },
    filter: {
      type: Object,
      default: () => {},
    },
    value: {
      type: String,
      default: () => "",
    },
    includeExternal: {
      type: Boolean,
      default: () => false,
    },
    hideDetails: {
      type: Boolean,
      default: () => false,
    },
    dense: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      debug: false,
      selectedTemplate: null,
    };
  },
  computed: {
    items() {
      return this.templates && this.templates.edges.length > 0
        ? this.templates.edges.map((e) => ({
            node: {
              ...e.node,
              name: e.node.isExternal ? `${e.node.name} (MP)` : e.node.name,
            },
          }))
        : [];
    },
    label() {
      return "Select Template:";
    },
  },
  methods: {
    onChange(event) {
      this.$emit("onSelect", event);

      if (event) {
        this.$emit("input", event.id);
      } else {
        this.$emit("input", "");
      }
    },
  },
  apollo: {
    templates: {
      query: ALL_TEMPLATES_SEARCH_QUERY,
      variables() {
        return {
          filter: this.filter,
          sort: { fieldName: "name", direction: "ASC" },
          includeExternal: this.includeExternal,
        };
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/TemplateListSelect.vue